<div class="text-center">
    <div [class]="icon + ' image-container'"></div>

    @if (description) {
        <p class="description">{{ description | translate }}</p>
    }
</div>
